<template>
  <div class="bespread-wrap module-layer1">
    <div class="screen-container" :class="!hideVideo ? 'bgNone' : ''">
      <!-- 根据不同的落地页展示不同的背景图 -->
      <img
        :src="require('../../assets/img/layer1/' + bgIdx + '.png')"
        alt=""
        srcset=""
        class="bgIdx"
        v-if="!hideVideo"
      />
      <div class="kv-content">
        <div
          v-if="hideVideo"
          class="kv-play-btn"
          :class="preview ? 'play-btn-preview' : 'play-btn-top'"
          @click="showVideo"
        ></div>

        <div class="b-position">
          <img
            :src="
              require('../../assets/img/layer1/' + lang + '/pre/slogan.png')
            "
            alt=""
            srcset=""
            class="kv-slogan"
            v-if="!preview"
          />
          <!-- steam组件 -->
          <div class="steampowered" v-if="preview">
            <iframe
              src="https://store.steampowered.com/widget/3882350/"
              frameborder="0"
              width="646"
              height="190"
            ></iframe>
          </div>
          <div class="page-channel-list">
            <div class="page-channel-item reg-icon">
              <!-- <img
                :src="
                preview?
                  require('../../assets/img/layer1/' + lang + '/pre-window.png')
                  :
                  require('../../assets/img/layer1/' + lang + '/pre/pre-window.png')

                "
                alt=""
                srcset=""
                @click="handlePreDownload('pcDownload')"
              /> -->
              <img
                :src="
                  require('../../assets/img/layer1/' + lang + '/pre-window.png')
                "
                alt=""
                srcset=""
                @click="handlePreDownload('pcDownload')"
              />
            </div>
            <div class="page-channel-item gp-icon" v-if="preview">
              <img
                :src="require('../../assets/img/layer1/' + lang + '/gp.png')"
                alt=""
                srcset=""
                @click="GP_reg('gp')"
              />
            </div>
            <div class="page-channel-item ios-icon" v-if="preview">
              <img
                :src="require('../../assets/img/layer1/' + lang + '/ap.png')"
                alt=""
                srcset=""
                @click="AS_reg('ios')"
              />
            </div>
            <div class="page-channel-item tt-icon" v-if="preview">
              <img
                :src="
                  require('../../assets/img/layer1/' + lang + '/pre-steam.png')
                "
                alt=""
                srcset=""
                @click="Steam_reg('steam')"
              />
            </div>
            <div class="page-channel-item pay-icon" v-if="preview">
              <img
                :src="
                  require('../../assets/img/layer1/' + lang + '/pay-en.png')
                "
                alt=""
                srcset=""
                @click="handlePay()"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="hideVideo">
        <video
          :loop="videoBgFlag"
          muted
          autoplay
          class="video-bg2 video-size"
          id="bgVideo"
          ref="bgVideo"
          @ended="bgVideoEnded"
        >
          <source :src="videoSrc" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      videoFlag: false,
      lang: "en",
      preview: true,
      hideVideo: true, // 通过这个值判断，落地页的时候不需要背景视频
      bgIdx: "",
      videoSrc: "https://resource-mp4.ujoygames.com/reso_en/bg_20250718.mp4",
      videoBgFlag: false
    };
  },

  created() {
    setTimeout(() => {
      this.videoFlag = true;
    }, 100);
    this.handlePre();
  },

  methods: {
    bgVideoEnded() {
      this.videoBgFlag = true;
      this.videoSrc =
        "https://resource-mp4.ujoygames.com/reso_en/bg_20251013.mp4";

      setTimeout(() => {
        this.$refs.bgVideo.load();
      }, 100);
    },
    handlePre() {
      let pre = "";
      let url = window.location.search;
      let preParam =
        url.indexOf("pre") >= 0
          ? this.common.getUrlParam("pre")
          : this.common.getUrlParam("pre");
      pre = preParam || "";
      // if (url.indexOf("pre") >= 0 && pre == 1) {
      //   this.preview = false;
      // } else {
      //   this.preview = true;
      // }

      if (url.indexOf("pre")) {
        if (pre == 1 || pre == "pc_1" || pre == "pc_2" || pre == "pc_3") {
          this.preview = false;
        } else {
          this.preview = true;
        }

        if (pre == "pc_1" || pre == "pc_2" || pre == "pc_3") {
          this.bgIdx = pre;
          this.hideVideo = false;
        } else {
          this.hideVideo = true;
        }
      }
    },
    handlePay() {
      window.open(`https://resonance.ujoygames.com/pay`, "_blank");
    },
    Steam_reg(val) {
      this.common.goShare(val);
    },
    handleRBtn() {
      this.$emit("handleShowReg");
    },
    AS_reg(val) {
      this.common.goShare(val);
    },
    GP_reg(val) {
      this.common.goShare(val);
    },
    showVideo() {
      this.$emit("handleVideo");
    },
    handlePreDownload(val) {
      gtag("event", "reso_pc_h5_download");
      this.gtag_report_conversion();
      if (!this.preview) {
        try {
          if (window.DOWNLOADURL.clickURL) {
            var t = window.DOWNLOADURL.clickURL;
            window.open(t, "_blank");
          }
        } catch (t) {
          this.getGclid();
          this.common.goShare(val);
        }
      } else {
        window.open(
          `https://resonance-apk.ujoygames.com/resonance_setup_us_150_release_250828.exe`
        );
      }
    },
    getGclid() {
      let gclid = "";
      let url = window.location.search;
      let gclidParam =
        url.indexOf("gclid") >= 0
          ? this.common.getUrlParam("gclid")
          : this.common.getUrlParam("gclid");
      gclid = gclidParam || "";
      window.GCLID_URL = gclid;
    },
    gtag_report_conversion(url) {
      var callback = function() {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-17364784388/M2zTCJ7HnJMbEISqlthA",
        value: 1.0,
        currency: "USD",
        event_callback: callback
      });
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer1 {
  // pointer-events: none;
  .pnone {
    display: none;
  }
  .pblock {
    display: block;
  }
  .bgIdx {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
  .bgNone {
    background-image: none !important;
  }
  .screen-container {
    background-image: url("../../assets/img/layer1/bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .kv-content {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
      .steampowered {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1vw;
      }
      .play-btn-top {
        top: 43%;
      }
      .play-btn-preview {
        top: 33%;
      }
      .kv-play-btn {
        background-image: url("../../assets/img/layer1/play-btn.png");
        background-size: 100% 100%;
        width: 120px;
        height: 120px;
        display: block;
        position: absolute;
        left: 50%;
        z-index: 2;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }

      .b-position {
        position: absolute;
        left: 50%;
        bottom: 4vw;
        transform: translateX(-50%);

        .page-channel-list {
          display: flex;
          align-items: end;
          justify-content: center;
          gap: 16px;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
          .page-channel-item {
            cursor: pointer;
            width: 210px;
            height: 67px;
          }
          .pay-icon {
            width: 215px;
            height: 87px;
          }
          // .page-channel-reg {
          //   cursor: pointer;
          //   width: 232px;
          //   height: 80px;
          // }
        }

        .kv-slogan {
          width: auto;
          height: 160px;
          display: block;
          margin-bottom: 2vw;
        }
      }
    }
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer1 {
    .play-btn-top {
      top: 43%;
    }
    .play-btn-preview {
      top: 40% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer1.vue